import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgManyToOne = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.50391 9.75L5.32981 9.75L8.62266 5.98867M8.62266 5.98867L12.1967 5.98867M8.62266 5.98867L1.50391 5.98867M8.62266 5.98867L5.32981 2.25003L1.50404 2.25003",
		stroke: "currentColor",
		strokeWidth: 1.1,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgManyToOne;
